// Secret key สำหรับ AES-256-GCM (ต้องตรงกับ backend)
const SECRET_KEY = "cmVnaXN0cmFyQHB1YmxpYy13ZWI=";

// Derive 32-byte AES-256 key จาก SECRET_KEY โดยใช้ SHA-256
async function getAESKey() {
  const keyBytes = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(SECRET_KEY)
  );
  return crypto.subtle.importKey("raw", keyBytes, { name: "AES-GCM" }, false, [
    "encrypt",
    "decrypt",
  ]);
}

// เข้ารหัส AES-256-GCM แล้ว encode เป็น Base64
// Wire format: base64( IV[12 bytes] || ciphertext || authTag[16 bytes] )
const aesEncrypt = async (value) => {
  const key = await getAESKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const plaintext = new TextEncoder().encode(JSON.stringify(value));
  const ciphertext = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    plaintext
  );
  // รวม IV + ciphertext+tag
  const result = new Uint8Array(12 + ciphertext.byteLength);
  result.set(iv, 0);
  result.set(new Uint8Array(ciphertext), 12);
  // แปลงเป็น Base64
  return btoa(String.fromCharCode(...result));
};

// ถอดรหัส Base64 แล้ว decrypt AES-256-GCM
const aesDecrypt = async (b64data) => {
  const key = await getAESKey();
  const raw = Uint8Array.from(atob(b64data), (c) => c.charCodeAt(0));
  const iv = raw.slice(0, 12);
  const ciphertext = raw.slice(12);
  const plaintext = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    ciphertext
  );
  return JSON.parse(new TextDecoder().decode(plaintext));
};

// เก็บ b64 functions ไว้สำหรับ backward compatibility (ถ้ามีที่อื่นใช้อยู่)
const b64EncodeUnicodeWithJson = (value) => {
  return btoa(JSON.stringify(value));
};

const b64DecodeUnicode = (str) => {
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};

const b64DecodeUnicodeWithJson = (value) => {
  return JSON.parse(b64DecodeUnicode(value));
};

export default {
  aesEncrypt,
  aesDecrypt,
  b64EncodeUnicodeWithJson,
  b64DecodeUnicode,
  b64DecodeUnicodeWithJson,
};
